import axios from 'axios';

export default async function deleteEventScheduledConfig(uid: number) {
  try {
    const idToken = window.sessionStorage.getItem('idToken')
    const res = await axios.delete(`${process.env.REACT_APP_REST_SERVER_URL}/scheduledConfigs/${uid}`, { headers: { authorization: idToken } });
    return res.data;
  } catch (err) {
    throw err;
  }
}